const SENSITIVE_KEY_PATTERN = /password|secret|token|authorization|credential/i

/**
 * Deep-redacts values under sensitive keys before they reach the logs.
 * Operation variables are logged verbatim by the error link, and some
 * operations carry secrets (e.g. getPublicDashboard's $password).
 */
export function redactSensitiveKeys<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map(item => redactSensitiveKeys(item)) as T
  }

  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [
        key,
        SENSITIVE_KEY_PATTERN.test(key) && entry != null ? '[REDACTED]' : redactSensitiveKeys(entry),
      ])
    ) as T
  }

  return value
}
